(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || {};
  const routes = T.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2);
    const withSep = (s, t, d) => { const [a, b] = s.split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? d + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withSep(Math.round(n).toString(), ',', '.');
      if (k === 'amount_with_comma_separator') return withSep(two, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withSep(Math.round(n).toString(), '.', ',');
      return withSep(two, ',', '.');
    });
  };

  /* Drawers */
  const overlay = $('[data-overlay]');
  let openDrawerEl = null, lastFocus = null;
  const focusables = (el) => $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter((x) => x.offsetParent !== null);
  function openDrawer(el) {
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); el.removeAttribute('inert');
    overlay && overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    openDrawerEl = el;
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => { const f = focusables(el); (f[0] || el).focus({ preventScroll: true }); });
  }
  function closeDrawer(keepOverlay) {
    if (!openDrawerEl) return;
    const el = openDrawerEl;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', '');
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openDrawerEl = null;
    if (!keepOverlay) { overlay && overlay.classList.remove('is-open'); document.body.classList.remove('is-locked'); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('aria-controls'))); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.matches('[data-overlay]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => {
    if (!openDrawerEl) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      const f = focusables(openDrawerEl); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Cart */
  const cartDrawer = () => document.getElementById('CartDrawer');
  const sectionsUrl = () => window.location.pathname;
  function setCount(n) { $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; }); }
  function renderDrawer(html) {
    const d = cartDrawer(); if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-inner]');
    const cur = d.querySelector('[data-cart-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
    const c = fresh && fresh.getAttribute('data-count');
    if (c !== null && c !== undefined) setCount(parseInt(c, 10) || 0);
  }
  function showCartError(msg) {
    const d = cartDrawer(); const box = d && d.querySelector('[data-cart-error]');
    if (box) { box.textContent = msg; box.hidden = false; }
  }
  async function cartRequest(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign(body, { sections: ['cart-drawer'], sections_url: sectionsUrl() })) });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }
  async function addToCart(items, btn, errorEl) {
    if (!cartDrawer()) return false;
    if (btn) btn.setAttribute('aria-busy', 'true');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    try {
      const data = await cartRequest(routes.cart_add_url, { items });
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); return true; }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      openDrawer(cartDrawer());
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { renderDrawerAndOpenWithError(err.message); }
    } finally { if (btn) btn.removeAttribute('aria-busy'); }
    return true;
  }
  async function renderDrawerAndOpenWithError(msg) { openDrawer(cartDrawer()); showCartError(msg); }
  async function changeLine(line, quantity, el) {
    const d = cartDrawer(); d && d.querySelector('[data-cart-inner]') && d.querySelector('[data-cart-inner]').setAttribute('aria-busy', 'true');
    try {
      const data = await cartRequest(routes.cart_change_url, { line, quantity });
      renderDrawer(data.sections && data.sections['cart-drawer']);
    } catch (err) {
      showCartError(err.message);
      d && d.querySelector('[data-cart-inner]') && d.querySelector('[data-cart-inner]').removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !cartDrawer()) return;
    e.preventDefault();
    const id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    const qty = form.querySelector('[name="quantity"]');
    const btn = form.querySelector('[type="submit"]');
    addToCart([{ id: parseInt(id.value, 10), quantity: qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1 }], btn, form.querySelector('[data-form-error]'));
  });

  document.addEventListener('click', (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick && cartDrawer()) { e.preventDefault(); addToCart([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }], quick); return; }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('.qty'); const input = wrap && wrap.querySelector('input');
      if (!input) return;
      const min = parseInt(input.min || '0', 10);
      const next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      input.value = next;
      if (input.dataset.line) changeLine(parseInt(input.dataset.line, 10), next);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const rm = e.target.closest('[data-remove-line]');
    if (rm && cartDrawer() && rm.closest('#CartDrawer')) { e.preventDefault(); changeLine(parseInt(rm.dataset.removeLine, 10), 0); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('input[data-line]');
    if (input && input.closest('#CartDrawer')) changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    const cartPageInput = e.target.closest('[data-cart-page] input[name="updates[]"]');
    if (cartPageInput) { clearTimeout(cartPageInput._t); cartPageInput._t = setTimeout(() => cartPageInput.form.submit(), 450); }
  });

  /* Variant picker */
  function initProduct(root) {
    const json = root.querySelector('[data-variants-json]');
    if (!json) return;
    let variants; try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    const form = root.querySelector('form[data-product-form]');
    const idInput = form && form.querySelector('[name="id"]');
    const btn = form && form.querySelector('[type="submit"]');
    const btnLabel = btn && btn.querySelector('[data-btn-label]');
    const priceNow = $$('[data-price-now]', root);
    const priceWas = $$('[data-price-was]', root);
    const saveEl = $$('[data-price-save]', root);
    const selectedLabel = root.querySelector('[data-selected-option]');
    const noteEl = root.querySelector('[data-scent-note]');
    const sticky = root.querySelector('[data-sticky-atc]');
    const updateUrl = root.hasAttribute('data-update-url');
    const labels = { add: btn ? btn.dataset.add : 'Add to bag', soldout: btn ? btn.dataset.soldout : 'Sold out', unavailable: btn ? btn.dataset.unavailable : 'Unavailable' };

    const fieldsets = $$('[data-option-index]', root);
    function selected() { return fieldsets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function apply(v) {
      if (idInput) idInput.value = v ? v.id : '';
      priceNow.forEach((el) => { if (v) el.textContent = formatMoney(v.price); });
      priceWas.forEach((el) => { const show = v && v.compare_at_price > v.price; el.hidden = !show; if (show) el.textContent = formatMoney(v.compare_at_price); });
      saveEl.forEach((el) => { const show = v && v.compare_at_price > v.price; el.hidden = !show; if (show) el.textContent = (el.dataset.prefix || 'Save') + ' ' + formatMoney(v.compare_at_price - v.price); });
      if (btn) {
        const ok = v && v.available;
        btn.disabled = !ok;
        const text = !v ? labels.unavailable : (v.available ? labels.add : labels.soldout);
        if (btnLabel) btnLabel.textContent = text;
        $$('[data-sticky-btn]', root).forEach((b) => { b.disabled = !ok; b.textContent = text; });
      }
      if (sticky) { const t = sticky.querySelector('[data-sticky-variant]'); if (t && v) t.textContent = v.title === 'Default Title' ? '' : v.title; }
      if (selectedLabel && v) selectedLabel.textContent = v.options[0];
      if (noteEl && v) { const src = root.querySelector('[data-note-for="' + CSS.escape(v.options[0]) + '"]'); noteEl.textContent = src ? src.textContent : ''; }
      if (v && v.featured_media_id) {
        const slide = root.querySelector('[data-media-id="' + v.featured_media_id + '"]');
        const track = slide && slide.parentElement;
        if (slide && track && track.scrollWidth > track.clientWidth + 4) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      if (updateUrl && v) { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
      // availability marks for single-option products
      if (fieldsets.length === 1) {
        $$('input', fieldsets[0]).forEach((inp) => { const m = variants.find((x) => x.options[0] === inp.value); inp.classList.toggle('is-unavailable', !m || !m.available); });
      }
    }
    root.addEventListener('change', (e) => {
      if (!e.target.closest('[data-option-index]')) return;
      const sel = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      apply(v);
    });
    const init = variants.find((x) => idInput && String(x.id) === String(idInput.value));
    if (init && fieldsets.length === 1) apply(init);

    // Gallery counter
    const track = root.querySelector('[data-gallery-track]');
    const counter = root.querySelector('[data-gallery-count]');
    if (track && counter) {
      const slides = track.children.length;
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / (track.clientWidth || 1)) + 1; counter.textContent = Math.min(i, slides) + ' / ' + slides; }); }, { passive: true });
    }

    // Sticky add to cart
    if (sticky && btn && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-atc-ready');
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', show);
      });
      io.observe(btn);
      $$('[data-sticky-btn]', sticky).forEach((b) => b.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); }));
    }
  }

  /* Delivery estimate */
  function initDelivery(el) {
    const min = parseInt(el.dataset.min || '1', 10), max = parseInt(el.dataset.max || '2', 10);
    const skip = (el.dataset.skip || '0').split(',').map((n) => parseInt(n, 10));
    const add = (n) => { const d = new Date(); let c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (!skip.includes(d.getDay())) c++; } return d; };
    const f = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    const out = el.querySelector('[data-delivery-dates]');
    if (out) out.textContent = min === max ? 'on ' + f(add(min)) : 'between ' + f(add(min)) + ' and ' + f(add(max));
    el.hidden = false;
  }

  /* Announcement rotation */
  function initAnnouncement(el) {
    const items = $$('.announcement__item', el);
    if (items.length < 2) { items[0] && items[0].classList.add('is-active'); return; }
    let i = 0, paused = false;
    items[0].classList.add('is-active');
    const mq = window.matchMedia('(min-width: 990px)');
    el.addEventListener('mouseenter', () => { paused = true; });
    el.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => {
      if (paused || (mq.matches && el.classList.contains('announcement__track--inline'))) return;
      items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, parseInt(el.dataset.speed || '4500', 10));
  }

  /* Reveal on scroll */
  function initReveal() {
    const els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: .05 });
    els.forEach((e) => io.observe(e));
  }

  /* Header */
  function initHeader() {
    const h = $('[data-header]'); if (!h) return;
    const set = () => document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
    set(); window.addEventListener('resize', set, { passive: true });
    window.addEventListener('scroll', () => h.classList.toggle('is-scrolled', window.scrollY > 4), { passive: true });
  }

  function init(scope) {
    $$('[data-product-root]', scope).forEach(initProduct);
    $$('[data-delivery]', scope).forEach(initDelivery);
    $$('[data-announcement]', scope).forEach(initAnnouncement);
  }
  document.addEventListener('DOMContentLoaded', () => { initHeader(); init(document); initReveal(); });
  document.addEventListener('shopify:section:load', (e) => { init(e.target); $$('[data-reveal]', e.target).forEach((x) => x.classList.add('is-in')); });
  window.Nashati = { addToCart, openDrawer, closeDrawer, formatMoney };
})();
